import { toCanonicalPayloadPath } from "~/utils/canonicalPayloadPath";

/**
 * Canonicalizes `payload.path` to pathname-only before the Nuxt router reads it.
 *
 * Server: `createNuxtApp` sets `payload.path` from the request URL. This plugin
 * stores pathname-only so cached HTML does not embed query params.
 * `ssrContext.url` and `event.node.req` stay original.
 *
 * Client: the same sanitization covers cached payloads that still contain a query.
 */
export default defineNuxtPlugin({
  name: "canonical-payload-path",
  enforce: "pre",
  order: -25,
  setup(nuxtApp) {
    if (typeof nuxtApp.payload.path === "string") {
      nuxtApp.payload.path = toCanonicalPayloadPath(nuxtApp.payload.path);
    }
  }
});
